import { useTranslation } from 'react-i18next'

import { ArrowLeftIcon } from '@phosphor-icons/react'

import * as Styles from './styles'

const BlockConfigurationBreadcrumb = ({ blockLabel, onBack }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container aria-label={t('Navegación de bloques')}>
      <Styles.BackLink type="button" onClick={onBack}>
        <ArrowLeftIcon size={16} />
        <Styles.BackLabel type="bodyMRegular">{t('Bloques')}</Styles.BackLabel>
      </Styles.BackLink>
      <Styles.Separator type="bodyMRegular">/</Styles.Separator>
      <Styles.CurrentLabel type="bodyMMedium">{blockLabel}</Styles.CurrentLabel>
    </Styles.Container>
  )
}

export default BlockConfigurationBreadcrumb
